import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
export default {
  name: "PatientDivision",
  props: ["source", "id"],
  watch: {
    source: function source() {
      this.init();
    },
    id: function id() {
      this.echart && this.echart.resize();
    }
  },
  data: function data() {
    return {
      echart: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.echart = echarts.init(document.getElementById("patientDivision"));
      this.echart.setOption({
        grid: {
          top: "15%",
          bottom: "15%"
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: "#F9FAFA",
            fontSize: this.size(12)
          }
        },
        yAxis: {
          name: "单位：人",
          type: "category",
          data: [">80", "70-79", "60-69", "<60"],
          nameTextStyle: {
            color: "#F9FAFA",
            fontSize: this.size(12)
          },
          axisLabel: {
            color: "#F9FAFA",
            fontSize: this.size(12)
          }
        },
        series: {
          type: "bar",
          itemStyle: {
            color: {
              type: "linear",
              colorStops: [{
                offset: 0,
                color: "#77F7D7" // 0% 处的颜色
              }, {
                offset: 1,
                color: "#C4D041" // 100% 处的颜色
              }]
            },

            borderRadius: [0, 20, 20, 0]
          },
          emphasis: {
            disabled: true
          },
          data: ["eightUp", "sevenUp", "sixUp", "zeroUp"].map(function (key) {
            return _this.source[key] || 0;
          }),
          barWidth: "40%"
        }
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    }
  }
};